// <div data-controller="designs--show">
//
// </div>
import { Controller } from "@hotwired/stimulus";
import api from "@/utils/api";

// https://stimulus.hotwired.dev/reference
export default class extends Controller {
  static targets = [ "" ];
  static classes = [ "" ]
  static values = {
    extId: String
  };

  initialize() {

  }

  view(e) {
    api.post(`/api/designs/${this.extIdValue}/view`).then((res) => {
      // nothing yet
    })
  }

  connect() {
  }

  disconnect() {

  }
}